import Echo from 'laravel-echo'
import authHeader from '../auth/auth-header'

import io from "socket.io-client"
import Vue from "vue";
window.io = io

let port = '6001'
if (process.env.VUE_APP_SOCKET_PORT) {
  port = process.env.VUE_APP_SOCKET_PORT
}

const socketOptions = {
  transports: ['websocket', 'polling'],
  rememberUpgrade: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  randomizationFactor: 0.5,
  timeout: 20000,
}

export function createAuthenticatedEcho() {
  return new Echo({
    broadcaster: "socket.io",
    host: process.env.VUE_APP_SOCKET_BACKEND_URL + `:${port}`,
    key: process.env.VUE_APP_LARAVEL_ECHO_SERVER_KEY,
    authEndpoint: process.env.VUE_APP_SOCKET_BACKEND_URL + '/broadcasting/auth',
    auth: {
      headers: authHeader()
    },
    ...socketOptions,
  })
}

const echoInstance = createAuthenticatedEcho()

Vue.prototype.$echo = echoInstance
